import React from 'react';
import './App.css';
import {
    Link
  } from 'react-router-dom';
function Navbar() {
    return (
        <div>
        <div className="cont">
            <h1 className='logoo curren'>Z-reels</h1>
            <h1 className='cop'>Z-reels</h1>
               <Link to={`/Action`} className="curren">Action</Link>
                <Link to={`/animation`} className="curren">Animation</Link>
                <Link to={`/Comedy`} className="curren">Comedy</Link>
                <Link to={`/Documentry`} className="curren">Documentry</Link>
                <Link to={`/Search`} className="curren">Search</Link>
                <div className="dropdown">
  {/* <span>Mouse over me</span> */}
  <button className='butt'><h1>☰</h1></button>
  <div className="dropdown-content">

                
               
        
  <p>  <Link to={`/`} className="yu">Home</Link></p>          
  <p>  <Link to={`/Action`} className="yu">Action</Link></p> <p><Link to={`/animation`} className="yu">Animation</Link></p> <p> <Link to={`/Comedy`} className="yu">Comedy</Link></p> <p>        <Link to={`/Documentry`} className="yu">Documentry</Link></p> <p><Link to={`/Search`} className="yu">Search</Link></p>
  </div>
        </div>
        <div>
</div>
</div>
        </div>
    )
}

export default Navbar
